export default function(formLoaded) {
    const under16Area = document.querySelector('#rental_prop_Booking_for_Under_16');
    if (!under16Area) {
        return;
    }

    if (typeof window.children == 'undefined') {
        throw "window.children expected";
    }

    if (window.children.length <= 0) {
        return;
    }

    const children = window.children;

    const firstNameEl = document.querySelector('#rental_prop_Child_First_Name');
    const lastNameEl = document.querySelector('#rental_prop_Child_Last_Name');
    const emailEl = document.querySelector('#rental_prop_Child_Email');
    const under16Checkbox = document.querySelector('#rental_prop_Are_You_Booking_for_Under_16');

    document.querySelector('#rental_prop_Child_First_Name').setAttribute('readonly', true);
    document.querySelector('#rental_prop_Child_Last_Name').setAttribute('readonly', true);
    document.querySelector('#rental_prop_Child_Email').setAttribute('readonly', true);
    document.querySelector('#rental_prop_Are_You_Booking_for_Under_16').setAttribute('readonly', true);

    let placeToInsertDropDown = document.querySelector('#personal_details > h3');
    if (!placeToInsertDropDown) {
        placeToInsertDropDown = document.querySelector('.user_modification_form > div');
    }
    const rowEl = document.createElement('div');
    rowEl.classList.add('row', 'planyo-form-row-wrapper');

    const outerEl = document.createElement('div');
    outerEl.classList.add('form-group', 'planyo-form-item-group', 'col-sm-6', 'narrow-col');

    const labelEl = document.createElement('label');
    labelEl.classList.add('control-label');
    labelEl.innerHTML = 'Reservation on behalf of<em>*</em>';

    const selectEl = document.createElement('select');
    selectEl.classList.add('with-status-border', 'form-control');

    let option;
    option = document.createElement('option');
    option.value = '-';
    option.innerHTML = 'Yourself';
    selectEl.append(option);
    // const childrenLength = children.length;

    for (let index = 0, len = children.length; index < len; index++) {
        option = document.createElement('option');
        option.value = index;
        option.innerHTML = children[index].first_name + ' ' + children[index].last_name;
        if (emailEl.value == children[index].email) {
            option.setAttribute('selected', true);
        }
        selectEl.append(option);
    }

    outerEl.append(labelEl);
    outerEl.append(selectEl);
    rowEl.append(outerEl);


    const notice = document.createElement('div');
    notice.classList.add('cnaq-status-message', 'cnaq-status-message--status');
    notice.innerHTML = 'Parents must accompany children below the age of 16';
    notice.style.display = 'none';

    selectEl.addEventListener('change', function(event) {
        if (selectEl.value == '-') {
            firstNameEl.value = '';
            lastNameEl.value = '';
            emailEl.value = '';
            under16Checkbox.removeAttribute('checked');
            notice.style.display = 'none';
            window.js_dates_changed();
            return;
        }

        firstNameEl.value = children[selectEl.value].first_name;
        lastNameEl.value = children[selectEl.value].last_name;
        emailEl.value = children[selectEl.value].email;
        under16Checkbox.setAttribute('checked', true);
        notice.style.display = 'block';
        window.js_dates_changed();
    });

    placeToInsertDropDown.parentNode.insertBefore(rowEl, placeToInsertDropDown.nextSibling);
    rowEl.parentNode.insertBefore(notice, rowEl.nextSibling);
}